module.exports = __webpack_public_path__ + "static/media/sliderimg1.6b16cb23.png";